import { forwardRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fromPaymentMethod, useAppDispatch } from '../../../store';
import { BuiltInPaymentForm } from './buiilt-in/BuiltInPaymentForm';

export const CardInformation = forwardRef((
  { accountId, enableSave, enableDelete }: {
    accountId: number;
    enableSave: boolean;
    enableDelete: boolean;
  },
  ref,
) => {
  const dispatch = useAppDispatch();
  const currentPaymentMethod = useSelector(fromPaymentMethod.selectOneByAccountId(accountId));
  const [paymentMethod, setPaymentMethod] = useState(currentPaymentMethod);

  useEffect(() => {
    const getPaymentMethod = async () => {
      if (accountId) {
        await dispatch(fromPaymentMethod.doGetPaymentMethod(accountId));
      }
    };
    getPaymentMethod().catch(() => {
    });
  }, [accountId, dispatch]);

  useEffect(() => {
    setPaymentMethod(currentPaymentMethod);
  }, [currentPaymentMethod]);

  return (
    <BuiltInPaymentForm
      ref={ref}
      accountId={accountId}
      enableSave={enableSave}
      enableDelete={enableDelete}
      currentCard={paymentMethod}
    />
  );
});
